import React from 'react';
import PropTypes from 'prop-types';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DayOfWeek } from './day-of-week';
import { Hour } from './hour';

export function WeeklyExtra({
  classNamePrefix,
  cronFormatter,
  dayOfWeek,
  hour,
  onChange,
  ariaLabelledby,
}) {
  const { WEEKLY } = cronFormatter.getCronFrequenciesEnum();

  return (
    <I18nContext.Consumer>
      {i18n => (
        <ReactTemplate
          model={{
            dayOfWeek: (
              <DayOfWeek
                classNamePrefix={classNamePrefix}
                cronFormatter={cronFormatter}
                onChange={(selectedDayOfWeek) => {
                  onChange(cronFormatter.toCronString({
                    dayOfWeek: selectedDayOfWeek,
                    frequency: WEEKLY,
                    hour,
                  }));
                }}
                selected={dayOfWeek}
                ariaLabelledby={ariaLabelledby}
              />
            ),
            hour: (
              <Hour
                classNamePrefix={classNamePrefix}
                cronFormatter={cronFormatter}
                onChange={(selectedHour) => {
                  onChange(cronFormatter.toCronString({
                    dayOfWeek,
                    frequency: WEEKLY,
                    hour: selectedHour,
                  }));
                }}
                selected={hour}
                ariaLabelledby={ariaLabelledby}
              />
            ),
          }}
          template={` ${i18n.getString(_TL_('CronFrequencyEditor_Weekly_Template'))}`}
        />
      )}
    </I18nContext.Consumer>
  );
}

WeeklyExtra.propTypes = {
  classNamePrefix: PropTypes.string.isRequired,
  cronFormatter: PropTypes.shape({
    toCronString: PropTypes.func,
  }).isRequired,
  dayOfWeek: PropTypes.number.isRequired,
  hour: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabelledby: PropTypes.string,
};

WeeklyExtra.defaultProps = {
  ariaLabelledby: '',
};
